
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/artigos-uteis",
      function () {
        return require("private-next-pages/artigos-uteis/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/artigos-uteis"])
      });
    }
  